import React from "react";
import { IoClose } from "react-icons/io5";
import { resolveMediaUrl } from "../../../../utility/media";
import { formatCurrency } from "../../../../utility/formatCurrency";
import { useTranslation } from "react-i18next";

const ViewTenderProcessDetailsModal = ({ isOpen, onClose, tender }) => {
    const {t} = useTranslation();
    if (!isOpen || !tender) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '950px', maxWidth: '95%' }}>
                {/* Modal Header matching your established style */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        {t('pageTitles.tenderProcessDetails')}
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
                        <IoClose />
                    </button>
                </div>
                <div className="staff-form-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>

                    <div className="px-6 text-sm">

                        <div className="flex gap-4 mb-2">
                            <label className="staff-modal-label whitespace-nowrap font-bold" style={{ marginBottom: 0, minWidth: '150px' }}>
                                {t('forms.tenderProcess.workTitle')} :
                            </label>
                            <span className="text-gray-800">{tender.workTypeName}</span>
                        </div>
                        <div className="flex gap-4">
                            <label className="staff-modal-label whitespace-nowrap font-bold" style={{ marginBottom: 0, minWidth: '150px' }}>
                                {t('common.description')} :
                            </label>
                            <span className="text-gray-700">{tender.description}</span>
                        </div>
                    </div>

                    {/* Primary Tender Information Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-3 mb-6 mt-2 px-6 text-sm">

                        <div className="flex gap-4">
                            <label className="staff-modal-label whitespace-nowrap font-bold" style={{ marginBottom: 0, minWidth: '150px' }}>
                                {t('tables.tenderProcess.tenderReferenceNo')} :
                            </label>
                            <span className="font-semibold">{tender.tenderReferenceNo}</span>
                        </div>
                        <div className="flex gap-4">
                            <label className="staff-modal-label whitespace-nowrap font-bold" style={{ marginBottom: 0, minWidth: '150px' }}>
                                {t('common.date')} :
                            </label>
                            <span className="text-gray-700">{tender.date || "N/A"}</span>
                        </div>
                        <div className="flex gap-4">
                            <label className="staff-modal-label whitespace-nowrap font-bold" style={{ marginBottom: 0, minWidth: '150px' }}>
                                {t('tables.tenderProcess.tenderId')} :
                            </label>
                            <span className="text-gray-700">{tender.tenderId}</span>
                        </div>
                        <div className="flex gap-4">
                            <label className="staff-modal-label whitespace-nowrap font-bold" style={{ marginBottom: 0, minWidth: '150px' }}>
                                {t('tables.tenderProcess.tenderType')} :
                            </label>
                            <span className="text-gray-700">{tender.tenderTypeName}</span>
                        </div>
                        <div className="flex gap-4">
                            <label className="staff-modal-label whitespace-nowrap font-bold" style={{ marginBottom: 0, minWidth: '150px' }}>
                                {t('tables.tenderProcess.formOfContract')} :
                            </label>
                            <span className="text-gray-700">{tender.formOfContract}</span>
                        </div>
                        <div className="flex gap-4">
                            <label className="staff-modal-label whitespace-nowrap font-bold" style={{ marginBottom: 0, minWidth: '150px' }}>
                                {t('tables.tenderProcess.tenderFee')} :
                            </label>
                            <span className="font-bold">{formatCurrency(tender.tenderFee)}</span>
                        </div>
                        <div className="flex gap-4">
                            <label className="staff-modal-label whitespace-nowrap font-bold" style={{ marginBottom: 0, minWidth: '150px' }}>
                                {t('tables.tenderProcess.tenderValue')} :
                            </label>
                            <span className="font-bold">{formatCurrency(tender.tenderValue)}</span>
                        </div>
                        <div className="flex gap-4">
                            <label className="staff-modal-label whitespace-nowrap font-bold" style={{ marginBottom: 0, minWidth: '150px' }}>
                                {t('tables.tenderProcess.emd')} :
                            </label>
                            <span className="font-bold">{formatCurrency(tender.emd)}</span>
                        </div>
                    </div>

                    {/* Attachments Table following your rest-of-app style */}
                    <div className="border border-black rounded-sm overflow-hidden mx-auto mb-4" style={{ width: '95%' }}>
                        <table className="w-full text-sm border-collapse">
                            <thead>
                                <tr className="bg-gray-100 border-b border-black">
                                    <th className="p-2 text-center border-r border-black font-bold w-12">{t('tables.srNo')}</th>
                                    <th className="p-2 border-r border-black font-bold text-left pl-4">{t('common.description')}</th>
                                    <th className="p-2 text-center font-bold w-48">{t('tables.file')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tender.attachmentData && tender.attachmentData.length > 0 ? (
                                    tender.attachmentData.map((item, index) => (
                                        <tr key={item.id || index} className="border-b border-black last:border-0">
                                            <td className="p-2 text-center border-r border-black">{index + 1}</td>
                                            <td className="p-2 pl-4 text-left border-r border-black whitespace-pre-wrap">
                                                {item.description}
                                            </td>
                                            <td className="p-2 text-center">
                                                {item.attachmentUrl ? (
                                                    <a
                                                        href={resolveMediaUrl(item.attachmentUrl)}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="underline hover:text-blue-800 break-all"
                                                    >
                                                        {item.attachmentName || "View File"}
                                                    </a>
                                                ) : (
                                                    <span className="text-gray-400 italic">{t('common.noAttachment')}</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="p-4 text-center text-gray-500 italic">
                                            {t('forms.tenderProcess.noTenderProcessAttachments')}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer matching your established Save button style */}
                <div className="staff-form-footer">
                    <button className="staff-btn-save px-10" onClick={onClose}>
                        {t('common.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewTenderProcessDetailsModal;